import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ClipboardList, Salad, Clock, Droplets, Leaf, Zap } from 'lucide-react';
const benefits = [{
  icon: ClipboardList,
  text: 'Plan de 7 días paso a paso — claro y fácil de seguir'
}, {
  icon: Salad,
  text: 'Combinaciones de alimentos que reducen la inflamación'
}, {
  icon: Clock,
  text: 'Horarios ideales para comer y descansar'
}, {
  icon: Droplets,
  text: 'Hábitos de hidratación que marcan la diferencia'
}, {
  icon: Leaf,
  text: 'Ingredientes naturales anti-inflamatorios'
}, {
  icon: Zap,
  text: 'Rutina matutina de 10 minutos para activar tu digestión'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    scale: 0.95
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function BenefitsSection() {
  return <section className="bg-wellness-white py-24 px-6" id="benefits" data-id="element-12">
      <div className="max-w-7xl mx-auto" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-14">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-wellness-dark mb-4" data-id="element-15">
            ¿Qué incluye tu guía?
          </h2>
          <p className="text-lg text-wellness-dark/70 max-w-2xl mx-auto" data-id="element-16">
            Todo lo que necesitas saber, simplificado en un plan de acción
            directo y sin complicaciones.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-17">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-lg shadow-wellness-dark/5 flex items-start space-x-6 border border-wellness-light-sage/50" data-id="element-18">
                <div className="bg-wellness-light-sage p-4 rounded-full flex-shrink-0" data-id="element-19">
                  <Icon className="w-8 h-8 text-wellness-green" data-id="element-20" />
                </div>
                <p className="text-wellness-dark font-medium text-lg leading-snug pt-2" data-id="element-21">
                  {benefit.text}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}